import React from 'react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How long does a project typically take?",
    answer: "Most web design projects take 4-8 weeks, depending on complexity. We'll give you a clear timeline during our initial consultation based on your specific needs."
  },
  {
    question: "Do you work with existing content and branding?",
    answer: "Absolutely. We can work with your existing brand guidelines, content, and assets. If you need help refining your messaging or branding, we can assist with that too."
  },
  {
    question: "Can you help with ongoing updates after launch?",
    answer: "Yes, we offer ongoing support and maintenance packages. Whether you need regular updates, security monitoring, or just occasional changes, we're here to help."
  },
  {
    question: "What do you need from us to get started?",
    answer: "We'll need to understand your business goals, target audience, and any existing brand materials. We'll guide you through everything else during our discovery process."
  },
  {
    question: "Do you provide hosting and domain setup?",
    answer: "We can help you choose the right hosting solution and handle domain setup. We work with reliable hosting providers to ensure your website performs well."
  },
  {
    question: "How do we measure success together?",
    answer: "We define success metrics with you upfront - whether that's more inquiries, better user engagement, or improved conversion rates. We track progress and share regular updates."
  }
];

export const CommonQuestions = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="py-32 bg-background relative" style={{ marginTop: 'var(--spacing-160)', marginBottom: 'var(--spacing-160)' }}>
      <div className="container mx-auto px-6">
        <div className="mb-16 max-w-content mx-auto">
          <div className="micro-label mb-3" style={{ color: 'hsl(var(--primary))', opacity: 0.9 }}>FAQ</div>
          <h2 className="heading-section font-display font-semibold mb-6 text-foreground animate text-left">
            Common questions
          </h2>
        </div>

        <div ref={elementRef} className="max-w-content mx-auto">
          <Accordion type="single" collapsible className="space-y-4" style={getRevealStyle(0)}>
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="card-matte border-none"
              >
                <AccordionTrigger className="text-left text-lg font-display font-medium text-foreground px-6 py-4 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-body leading-relaxed px-6 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};